import type {FogScene} from "./SoftFogWorkerProtocol.ts";

/** Geometry stays in world coordinates; only the raster viewport is reduced. */
export function fogSceneAtResolution(scene: FogScene): FogScene {
    const ratio = 0.25;
    return {
        ...scene,
        stageSize: {
            width: Math.max(1, Math.ceil(scene.stageSize.width * ratio)),
            height: Math.max(1, Math.ceil(scene.stageSize.height * ratio)),
        },
        transform: {
            x: scene.transform.x * ratio,
            y: scene.transform.y * ratio,
            scale: scene.transform.scale * ratio,
        },
    };
}
